"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _layers = require("../../../constants/layers");
var _spacing = require("../../../constants/spacing");
const modalTheme = (0, _sdsThemeInternal.themed)({
  actionsPadding: {
    "lodestar-light": `${_spacing.sizes.small}px ${_spacing.sizes.small}px 0`,
    "ursa-light": `${_designTokens.space.space50} ${_designTokens.space.space50} 0`
  },
  backgroundColor: (0, _designTokensReact.color)("color--background--surfaces--work"),
  boxShadow: {
    "lodestar-light": `${_layers.shadows.modal()}`,
    "ursa-light": (0, _designTokensReact.color)("elevation--high")
  },
  bodyGutter: {
    "lodestar-light": "legacy",
    "ursa-light": "space60"
  },
  borderRadius: {
    "lodestar-light": "0px",
    "ursa-light": _designTokens.border.radius50
  },
  color: (0, _designTokensReact.color)("color--text--neutral--strong")
});
exports.modalTheme = modalTheme;
//# sourceMappingURL=modalTheme.js.map